import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import React from "react";
import { SubmitButton } from "../../../../@coherent/react-hook-form";
import { Button } from "reactstrap";
import { Reference } from "./Reference";

export const Step4Form = ({ required = true }) => {
  const { fields } = useFieldArray({
    name: "references",
  });

  return (
    <>
      <h3 className="tw-text-lg mb-4">References</h3>
      <p>
        We request that you fill in the details of two referees that you have
        known for{" "}
        <strong>
          at least 2 years. Please provide details of people who have known you
          or worked alongside you in a professional or community capacity.
        </strong>{" "}
        We do not accept any references from family members.
      </p>
      <p className="small">
        We reserve the right to make additional character enquiries considered
        necessary and we may also call your referees.
      </p>
      {fields.map((i, idx) => (
        <Reference field={i} key={i.id} index={idx} required={required} />
      ))}
    </>
  );
};

export const Step4 = ({ onSubmit, defaultValues, onBack }) => {
  const methods = useForm({
    mode: "onBlur",
    defaultValues,
    shouldUnregister: true,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Step4Form />
        <div className="tw-flex tw-justify-between">
          <Button onClick={onBack}>Back</Button>
          <SubmitButton>Continue</SubmitButton>
        </div>
      </form>
    </FormProvider>
  );
};
